import { CircularProgress, Stack } from '@mui/material'

const Loading = () => {
  return (
    <Stack justifyContent="center" alignItems="center" sx={{ height: '50vh' }}>
      <CircularProgress />
    </Stack>
  )
}

export default Loading
